import { Input } from '@medsimples/design-system/src/components';
import Phone from '@public/icons/phone/phone';
import type { ChangeEventHandler } from 'react';
import ReactInputMask from 'react-input-mask';
import { useDesignTokens } from '../../app/providers/design_tokens_provider';

interface Props {
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
}

export default function AuthPhoneInput(props: Props) {
  const tokens = useDesignTokens();

  const { onChange, value } = props;

  return (
    <Input
      as={ReactInputMask}
      leftElement={
        <Phone color={tokens.text.secondary.color} width={17} height={17} />
      }
      mask='+55 (99) ?99999999'
      maskChar={null}
      formatChars={{
        '9': '[0-9]',
        '?': '[0-9]',
      }}
      placeholder='+55 (00) 0000-0000'
      value={value}
      onChange={onChange}
      marginBottom={2}
    />
  );
}
